// extracted by mini-css-extract-plugin
export default {"headerBar":"yM-z","pointsSection":"zM-z","goToDashboard":"AM-z"};